import MattersTableContactView from 'pages/matters/tables/MattersTableContactView';
import { GroupMemberRoleType, PartyGroup } from 'types/groups';

interface Props {
    partyGroup: PartyGroup;
}

const CasesView: React.FC<Props> = ({ partyGroup }) => {
    let partyIds = partyGroup.parties
        ?.filter((item) => item.groupMemberRoleTypeCode === GroupMemberRoleType.MEMBER)
        .map((item) => item.party.id);
    if (!partyIds || partyIds.length === 0) {
        partyIds = [0];
    }

    return <MattersTableContactView contactIdList={partyIds} />;
};

export default CasesView;
